import React, { Component } from 'react';
import { object, func } from 'prop-types';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import './datepicker.css';

import {
  Bar,
  StyledDateRangePickerWrapper,
  SubtitleBar,
  Subtitle,
} from './DateControl.style';

class DateControl extends Component {
  state = {
    focusedInput: null,
    startDate: this.props.startDate,
    endDate: this.props.endDate,
    minimumNights: 6,
  };

  /**
   * Check if the component is updated based on the props, if so update the state as well.
   */
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.startDate !== prevProps.startDate) {
      this.setState({ startDate: this.props.startDate });
    }
    if (this.props.endDate !== prevProps.endDate) {
      this.setState({ endDate: this.props.endDate });
    }
  }

  /**
   * Handle changes in dates so we can use it to submit after the date picker
   * is closed.
   */
  onDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  /**
   * Change focus of the date picker based on the date selection, either start or
   * end date.
   */
  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
  };

  /**
   * Submit dates via a prop function, this will eventually save the new dates to the URL.
   */
  submitDates = ({ startDate, endDate }) => {
    /** Only submit dates if the start and end date are set */
    if (startDate && endDate) {
      /**
       * First update the component state so we actual save a date. In cases when a date is
       * removed from the date picker, we want to reset this date to a default.
       */
      this.setState(
        { startDate, endDate },
        this.props.submitDates({ startDate, endDate })
      );
    }
  };

  render() {
    const { startDate, endDate, focusedInput, minimumNights } = this.state;

    /**
     * Determine the initial visible month (the date to focus the date picker on).
     * This could either be the end/start date from the state or the initial state
     * from props.
     */
    const initialVisibleMonth = () => {
      const newEndDate = endDate || this.props.endDate;
      const newStartDate = startDate || this.props.startDate;
      return focusedInput === 'endDate' ? newEndDate : newStartDate;
    };

    return (
      <Bar>
        <StyledDateRangePickerWrapper>
          <SubtitleBar>
            <Subtitle>Start date</Subtitle>
            <Subtitle>End date</Subtitle>
          </SubtitleBar>
          <DateRangePicker
            ref={(c) => {window.keencorp.dateRangePicker = c}}
            disabled={!window.keencorp.date_enabled}
            displayFormat="YYYY-MM-DD"
            firstDayOfWeek={1}
            transitionDuration={0}
            minimumNights={minimumNights}
            noBorder
            showDefaultInputIcon
            hideKeyboardShortcutsPanel
            startDatePlaceholderText="Start date"
            startDateId="startDate"
            startDate={startDate}
            endDatePlaceholderText="End date"
            endDateId="endDate"
            endDate={endDate}
            onDatesChange={this.onDatesChange}
            focusedInput={focusedInput}
            onFocusChange={this.onFocusChange}
            isOutsideRange={() => false}
            initialVisibleMonth={() => initialVisibleMonth()}
            onClose={this.submitDates}
          />
        </StyledDateRangePickerWrapper>
      </Bar>
    );
  }
}

DateControl.propTypes = {
  startDate: object.isRequired,
  endDate: object.isRequired,
  submitDates: func.isRequired,
};

export default DateControl;



// WEBPACK FOOTER //
// ./src/components/DateControl/DateControl.js